import query from './APIServices'

interface Category {
  id: number
  name: string
  description: string
  createdAt: string
}

interface CategoryParams {
  id?: number
  name: string
  description: string
}

export const getContainerCategories = async (params?: { search?: string }) => {
  const cleanParams = params?.search ? { search: params.search } : undefined

  const response = await query.get('/cargo/category', {
    params: cleanParams,
  })
  return response?.data.items as Category[]
}

export const createNewCategory = async (params: CategoryParams) =>
  await query.post('/cargo/category', params)

export const editNewCategory = async (params: CategoryParams) =>
  await query.patch(`/cargo/category/${params.id}`, {
    name: params.name,
    description: params.description,
  })

export const deleteCategory = async (idCategory: number) =>
  await query.deleteAPI(`/cargo/category/${idCategory}`)
